import { useState } from 'react';

/** Inline order editor for list screens; saves on blur / Enter when the value changed. */
export function OrderInput({
  value,
  onSave,
}: {
  value: number | undefined;
  onSave: (n: number) => Promise<void> | void;
}) {
  const [v, setV] = useState(value === undefined ? '' : String(value));
  const commit = () => {
    const n = Number(v);
    if (v.trim() === '' || !Number.isFinite(n) || n === value) return;
    void onSave(n);
  };
  return (
    <input
      type="number"
      className="form-control form-control-sm"
      style={{ width: 80 }}
      aria-label="Order"
      value={v}
      onChange={(e) => setV(e.target.value)}
      onBlur={commit}
      onKeyDown={(e) => e.key === 'Enter' && (e.target as HTMLInputElement).blur()}
    />
  );
}
